module.exports = __webpack_public_path__ + "img/booking.ced3c5aa.jpg";